import { home_navMenu_children, bigScreen_navMenu_children, app_navMenu_children } from "./menus/index"
import { getOptDes } from "./menus/optDes"
const cxNavMenu = {
  name: "cxNavMenu",
  desc: "",
  render: () => import("./render/index.vue"),
  optDes: getOptDes,
  enable: true,
  // 屏蔽多级菜单，原因是多级菜单未开放数据绑定，一帆觉得直接用导航菜单就可以了。多个反而容易造成混乱
  menus: {
    app: [
      {
        name: "多级菜单",
        group: "element",
        children: app_navMenu_children,
        enable() {
          return false
        },
        sort: 60
      }
    ],
    bigScreen: [
      {
        name: "多级菜单",
        children: bigScreen_navMenu_children
      }
    ],
    portal: [
      {
        name: "多级菜单",
        children: home_navMenu_children,
        group: "element",
        enable() {
          return false
        },
        sort: 60
      }
    ]
  },
  toolbars: [
    {
      name: "cxNavMenu",
      label: "多级菜单",
      comp: {
        navMenuComponentData: () => import("./toolbars/navMenu-options-data.vue"),
        navMenuComponentSetting: () => import("./toolbars/navMenu-options-setting.vue"),
        navMenuComponentStyle: () => import("./toolbars/navMenu-options-style.vue"),
        navMenuComponentConfig: () => import("./toolbars/navMenu-options-config.vue")
      }
    }
  ]
}

export default cxNavMenu
